import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageSEO from "@/components/base/PageSEO";
import CategoryHeader from "./components/CategoryHeader";
import ArticleGrid from "./components/ArticleGrid";
import { categoryInfo, categoryArticles } from "@/mocks/categories";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  const info = slug ? categoryInfo[slug] : undefined;
  const articles = slug ? categoryArticles[slug] : undefined;

  if (!info) {
    return (
      <>
        <PageSEO
          title="分类不存在"
          description="你要找的分类可能已经被移除，或者从未存在过。访问黑料网浏览更多分类。"
          keywords="黑料网,娱乐八卦,明星黑料"
          canonicalUrl="http://ijcbfgs.cn/"
        />
        <Navbar />
        <main className="pt-16 md:pt-18">
          <div className="max-w-[780px] mx-auto px-6 md:px-10 py-20 text-center">
            <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center bg-background-100 rounded-full">
              <i className="ri-folder-open-line text-3xl text-foreground-400"></i>
            </div>
            <h1 className="font-heading text-2xl font-bold text-foreground-950 mb-3">
              分类不存在
            </h1>
            <p className="text-foreground-500 mb-8">
              你要找的分类可能已经被移除，或者从未存在过。
            </p>
            <div className="flex items-center justify-center gap-3 flex-wrap">
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 rounded-lg font-medium text-sm transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-arrow-left-line"></i>
                返回首页
              </Link>
              <Link
                to="/category/star-gossip"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 border border-background-200/70 text-foreground-700 rounded-lg font-medium text-sm transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-star-line"></i>
                明星爆料
              </Link>
            </div>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <PageSEO
        title={info.name}
        description={`${info.description} | 共${info.count.toLocaleString()}篇文章，实时更新 - 黑料网`}
        keywords={`${info.name},黑料网,娱乐八卦,${info.name}爆料`}
        canonicalUrl={`http://ijcbfgs.cn/category/${slug}`}
        ogImage={info.image}
      />
      <Navbar />
      <main className="pt-16 md:pt-18">
        <CategoryHeader
          name={info.name}
          icon={info.icon}
          description={info.description}
          count={info.count}
          image={info.image}
        />
        <ArticleGrid articles={articles || []} />

        {/* Browse other categories */}
        <section className="px-6 md:px-10 pb-14 md:pb-18 bg-background-50">
          <div className="max-w-[1400px] mx-auto">
            <div className="border-t border-background-200/70 pt-10">
              <h3 className="font-heading text-lg font-semibold text-foreground-950 text-center mb-6">
                浏览其他标签
              </h3>
              <div className="flex flex-wrap items-center justify-center gap-3">
                {Object.values(categoryInfo)
                  .filter((cat) => cat.slug !== slug)
                  .map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-2 px-4 py-2.5 bg-background-100 hover:bg-background-200 border border-background-200/70 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-all duration-200 cursor-pointer"
                    >
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className={`${cat.icon} text-primary-500 text-sm`}></i>
                      </div>
                      {cat.name}
                      <span className="text-xs text-foreground-400 ml-1">{cat.count}</span>
                    </Link>
                  ))}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
